export default "__VITE_ASSET__a0ae222d__"